'use strict';

class BotsListController {
  constructor($log,
              $scope,
              $rootScope,
              $q,
              $timeout,
              $filter,
              $state,
              $stateParams,
              utils,
              config,
              BotsService,
              VirtualPaginator,
              ToastsService) {

    // #region Define fields

    const $t = $filter('translate');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';
    const SELECTED_ORGANIZATION_LOCAL_STORAGE_KEY = 'Selected-Org';
    const SELECTED_BOT_LOCAL_STORAGE_KEY = 'Selected-Bot';
    const ALL_ORGS_LOCAL_STORAGE_KEY = 'Organizations-All';

    $scope.loading = false;
    $scope.botsPage = {};
    let $botsPage = $scope.botsPage;
    $botsPage.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY); // Current org
    const BOTS_FILTER_LOCAL_STORAGE_KEY = 'Filter-Bots-' + $botsPage.orgInfo.id;
    $scope.botCategories = config.getConfigByKey('botCategories');
    const filterKey = 'Filter-Bots-' + $botsPage.orgInfo.id;
    let CACHE_FILTER = false;

    // Request constants
    const REQUEST_LIMIT = 100;

    $scope.selection = $state.params && $state.params.from; // Where we came from to this page
    let selectedTarget = $botsPage.orgInfo;
    if ($scope.selection === 'location') {
      selectedTarget = utils.getStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY);
    } else if ($scope.selection === 'organization' || $state.params.organizationId) {
      if ($state.params.organizationId) {
        const orgs = utils.getStorageItem(ALL_ORGS_LOCAL_STORAGE_KEY);
        selectedTarget = orgs.find(o => o.id.toString() === $state.params.organizationId.toString());
      } else {
        selectedTarget = utils.getStorageItem(SELECTED_ORGANIZATION_LOCAL_STORAGE_KEY);
      }
    }
    if (!selectedTarget) {
      selectedTarget = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    }

    // #endregion

    angular.extend($scope, {
      searchBots: searchBots,
      back: back,
      processCategories: processCategories,
      purchaseBot: purchaseBot,
      viewBot: viewBot,

      // Filter
      toggleFilter: toggleFilter,
      closeFilter: closeFilter,
      isFilterDirty: isFilterDirty,
      resetFilter: resetFilter,
      filterBots: filterBots
    });

    init();

    // Please, no code execution below this line - only function definitions
    // ---------------------------------------------------------------------

    // #region Methods -------------------------------------

    function init() {
      initFilter();

      $scope.paginator = new VirtualPaginator(getBots);
      $scope.paginator.sortBy = 'name';
      $scope.paginator.sortByReverse = false;
    }

    function back() {
      let targetRoute = 'main.organizations.edit';
      if ($scope.selection === 'location') {
        targetRoute = 'main.locations.edit';
      }
      $state.go(targetRoute, {
        tab: 'bots'
      });
    }

    // #region Filter related functions

    function initFilter() {
      $scope.filter = {};
      $scope.filter.searchVal = $stateParams.searchBy || '';

      // Restore from cache only if nothing was transferred via URL query parameters
      if (!isFilterDirty()) {
        initFilterFromCache();
      }

      saveFilter();

      // #region Watchers

      /* $scope.$watch('filter', function() {
        // We save filter only after it was applied
        saveFilter();
      }, true); */

      // #endregion

      // Get child organizations if they are exist
      $scope.childOrgs = !$scope.chooseOrg.parentId
        ? utils.getChildOrganizations($scope.allOrgs, $scope.chooseOrg.id)
        : [];
    }

    /**
     * Init filter object from localStorage cache
     */
    function initFilterFromCache() {
      if (CACHE_FILTER) {
        let params = utils.getStorageItem(BOTS_FILTER_LOCAL_STORAGE_KEY);
        if (params) {
          $scope.filter = params;
        }
      }
    }

    /**
     * Save filter to localStorage
     */
    function saveFilter() {
      if (CACHE_FILTER) {
        utils.setStorageItem(BOTS_FILTER_LOCAL_STORAGE_KEY, $scope.filter);
      }
    }

    /**
     * Is filter has some values set
     * @param {boolean} filterOnly To check only filter without search value
     * @return {boolean}
     */
    function isFilterDirty(filterOnly) {
      if (!$scope.filter) {
        return false;
      }
      let tempFilter = angular.copy($scope.filter);
      if (filterOnly) {
        tempFilter.searchVal = null;
      }
      return Object.keys(tempFilter)
        .some(key => (key === 'categories')
          ? tempFilter[key] && tempFilter[key].length > 0
          : !!tempFilter[key]);
    }

    /**
     * Toggle filter UI visibility
     */
    function toggleFilter() {
      $('#filter').transition('fade down');
    }

    /**
     * Hide filter UI
     */
    function closeFilter() {
      let visible = $('#filter').transition('is visible');
      if (visible) {
        $('#filter').transition('hide');
      }
    }

    function resetFilter() {
      if ($scope.loading || !$scope.paginator) {
        return;
      }
      $scope.filter = {};
      closeFilter();
      saveFilter();
      $scope.paginator.reload();
    }

    function searchBots() {
      if ($scope.loading || !$scope.paginator) {
        return;
      }
      saveFilter();
      $scope.paginator.reload();
    }

    function filterBots() {
      if ($scope.loading || !$scope.paginator) {
        return;
      }
      closeFilter();
      saveFilter();
      $scope.paginator.reload();
    }

    // #endregion

    // #endregion

    // #region Bots Functions ------------------------------

    /**
     * Search bots
     * @return {Promise}
     */
    function getBots() {
      $scope.loading = true;
      let params = {
        limit: REQUEST_LIMIT
      };

      if ($scope.selection === 'location') {
        params.locationId = selectedTarget.id;
      } else {
        params.organizationId = selectedTarget.id;
      }

      if ($scope.filter.searchVal) {
        params.searchBy = '*' + $scope.filter.searchVal + '*';
      }
      if ($scope.filter.categories) {
        params.category = $scope.filter.categories;
      }

      return BotsService.searchBots(params)
        .then(data => {
          $botsPage.bots = data.apps || [];
          $scope.loading = false;
          return $botsPage.bots;
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
          return $q.reject(err);
        });
    }

    function processCategories(data) {
      let result = '';
      if (!data || data === '') {
        return result;
      }

      let array = data.split(',');
      array.forEach((value, index) => {
        let category = $scope.botCategories.find(el => el.id === value);
        result += $t(category.name);
        if (index < array.length - 1) {
          result += ', ';
        }
      });

      return result;
    }

    /**
     * Goto bot details page
     */
    function viewBot(bot, $event) {
      let params = {};
      if ($scope.selection === 'location') {
        params.locationId = selectedTarget.id;
      } else {
        params.organizationId = selectedTarget.id;
      }
      params.from = $state.params.from;
      utils.setStorageItem(SELECTED_BOT_LOCAL_STORAGE_KEY, { bot: bot });
      $state.go('main.bots.info', params);
    }

    /**
     * Assign bot to location or organization
     */
    function purchaseBot(bot, $event) {
      if (!bot || !bot.bundle) {
        return;
      }
      if ($scope.selection === 'location') {
        return BotsService.purchaseLocationBot(selectedTarget.id, bot.bundle)
          .then(data => {
            ToastsService.success($t('bots.successPurchase'), $t('bots.successPurchaseDesc'));
            $state.go('main.locations.edit', {
              tab: 'bots',
            });
          }, err => {
            $scope.loading = false;
            utils.handleApiError(err);
          });
      }
      return BotsService.purchaseOrganizationBot(selectedTarget.id, bot.bundle)
        .then(data => {
          ToastsService.success($t('bots.successPurchase'), $t('bots.successPurchaseDesc'));
          $state.go('main.organizations.edit', {
            tab: 'bots',
          });
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    // #endregion

  }
}

export default angular
  .module('main.botsList.controller', [])
  .controller('BotsListController', BotsListController)
  .name;
